// import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

// const ThemeContext = createContext(null);
// const FONT_SIZE_KEY = "fontSizePreference";
// const FONT_SIZE_ORDER = ["decrease", "normal", "increase"];
// const FONT_SIZE_MAP = {
//   decrease: 15,
//   normal: 16,
//   increase: 18,
// };

// const getInitialTheme = () => {
//   if (typeof window === "undefined") {
//     return "light";
//   }

//   const savedTheme = window.localStorage.getItem("theme");
//   if (savedTheme === "light" || savedTheme === "dark") {
//     return savedTheme;
//   }

//   return window.matchMedia("(prefers-color-scheme: dark)").matches
//     ? "dark"
//     : "light";
// };

// const getInitialFontSize = () => {
//   if (typeof window === "undefined") {
//     return "normal";
//   }

//   const savedFontSize = window.localStorage.getItem(FONT_SIZE_KEY);
//   if (FONT_SIZE_ORDER.includes(savedFontSize)) {
//     return savedFontSize;
//   }

//   return "normal";
// };

// export function ThemeProvider({ children }) {
//   const [theme, setTheme] = useState(getInitialTheme);
//   const [fontSize, setFontSize] = useState(getInitialFontSize);

//   useEffect(() => {
//     document.documentElement.setAttribute("data-bs-theme", theme);
//     document.body.setAttribute("data-bs-theme", theme);
//     window.localStorage.setItem("theme", theme);
//   }, [theme]);

//   useEffect(() => {
//     const rootFontSize = FONT_SIZE_MAP[fontSize] || FONT_SIZE_MAP.normal;
//     document.documentElement.setAttribute("data-font-size", fontSize);
//     document.documentElement.style.fontSize = `${rootFontSize}px`;
//     window.localStorage.setItem(FONT_SIZE_KEY, fontSize);
//   }, [fontSize]);

//   useEffect(() => {
//     const handleStorage = (event) => {
//       if (event.key === "theme" && (event.newValue === "light" || event.newValue === "dark")) {
//         setTheme(event.newValue);
//       }

//       if (event.key === FONT_SIZE_KEY && FONT_SIZE_ORDER.includes(event.newValue)) {
//         setFontSize(event.newValue);
//       }
//     };

//     window.addEventListener("storage", handleStorage);
//     return () => window.removeEventListener("storage", handleStorage);
//   }, []);

//   const updateFontSize = (direction) => {
//     setFontSize((currentSize) => {
//       const currentIndex = FONT_SIZE_ORDER.indexOf(currentSize);

//       if (direction === "increase") {
//         return FONT_SIZE_ORDER[Math.min(currentIndex + 1, FONT_SIZE_ORDER.length - 1)];
//       }

//       if (direction === "decrease") {
//         return FONT_SIZE_ORDER[Math.max(currentIndex - 1, 0)];
//       }

//       return "normal";
//     });
//   };

//   const value = useMemo(
//     () => ({
//       theme,
//       setTheme,
//       toggleTheme: () => setTheme((currentTheme) => (currentTheme === "light" ? "dark" : "light")),
//       isDark: theme === "dark",
//       fontSize,
//       setFontSize,
//       increaseFontSize: () => updateFontSize("increase"),
//       decreaseFontSize: () => updateFontSize("decrease"),
//       resetFontSize: () => updateFontSize("reset"),
//     }),
//     [fontSize, theme],
//   );

//   return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
// }

// export function useTheme() {
//   const context = useContext(ThemeContext);

//   if (!context) {
//     throw new Error("useTheme must be used within ThemeProvider");
//   }

//   return context;
// }
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext(null);

const FONT_SIZE_KEY = "fontSizePreference";

// ✅ Step-based sizes
const FONT_SIZES = [12, 14, 16, 18, 20, 22];
const DEFAULT_INDEX = 2; // 16px

const getInitialTheme = () => {
  if (typeof window === "undefined") return "light";

  const savedTheme = window.localStorage.getItem("theme");
  if (savedTheme === "light" || savedTheme === "dark") return savedTheme;

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

// ✅ Store index
const getInitialFontSize = () => {
  if (typeof window === "undefined") return DEFAULT_INDEX;

  const saved = parseInt(window.localStorage.getItem(FONT_SIZE_KEY), 10);

  if (!isNaN(saved) && saved >= 0 && saved < FONT_SIZES.length) {
    return saved;
  }

  return DEFAULT_INDEX;
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);
  const [fontIndex, setFontIndex] = useState(getInitialFontSize);
const [mode, setMode] = useState(null);
  // ✅ Theme apply
  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme);
    document.body.setAttribute("data-bs-theme", theme);
    window.localStorage.setItem("theme", theme);
  }, [theme]);

  // ✅ Font size apply
  useEffect(() => {
    const size = FONT_SIZES[fontIndex];

    document.documentElement.style.fontSize = `${size}px`;
    document.documentElement.setAttribute("data-font-size", size);

    window.localStorage.setItem(FONT_SIZE_KEY, fontIndex);
  }, [fontIndex]);

  // ✅ Sync across tabs
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "theme") {
        setTheme(event.newValue);
      }

      if (event.key === FONT_SIZE_KEY) {
        const newIndex = parseInt(event.newValue, 10);
        if (!isNaN(newIndex)) {
          setFontIndex(newIndex);
        }
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  // ✅ UPDATED LOGIC

  // const increaseFontSize = () => {
  //   setFontIndex((prev) => {
  //     // from Normal (16) → start from 18
  //     if (prev === DEFAULT_INDEX) return DEFAULT_INDEX + 1;

  //     return Math.min(prev + 1, FONT_SIZES.length - 1);
  //   });
  // };

  // const decreaseFontSize = () => {
  //   setFontIndex((prev) => {
  //     // from Normal (16) → start from 14
  //     if (prev === DEFAULT_INDEX) return DEFAULT_INDEX - 1;

  //     return Math.max(prev - 1, 0);
  //   });
  // };

  // const resetFontSize = () => {
  //   setFontIndex(DEFAULT_INDEX); // always 16
  // };
const increaseFontSize = () => {
  setFontIndex((prev) => {
    // jo already increase mode ma hoy
    if (mode === "inc") {
      return Math.min(prev + 1, FONT_SIZES.length - 1);
    }

    // new click → always 18
    return DEFAULT_INDEX + 1;
  });

  setMode("inc");
};

const decreaseFontSize = () => {
  setFontIndex((prev) => {
    // jo already decrease mode ma hoy
    if (mode === "dec") {
      return Math.max(prev - 1, 0);
    }

    // new click → always 14
    return DEFAULT_INDEX - 1;
  });

  setMode("dec");
};

const resetFontSize = () => {
  setFontIndex(DEFAULT_INDEX); // 16
  setMode(null); // reset mode
};
  const value = useMemo(
    () => ({
      theme,
      setTheme,
      toggleTheme: () =>
        setTheme((t) => (t === "light" ? "dark" : "light")),
      isDark: theme === "dark",

      fontSize: FONT_SIZES[fontIndex],
      fontIndex,

      increaseFontSize,
      decreaseFontSize,
      resetFontSize,
    }),
    [theme, fontIndex]
  );

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return context;
}